<div class="flex-column">
  @if (mode === 'takePicture') {
  <div class="flex-row" style="overflow: auto">
    @for (camera of availableCameras; track $index) {

    <button class="small-btn hide-on-print" (click)="startCamera(camera.id)">
      {{ camera.name }}
    </button>

    }
  </div>
  <div class="flex-row" style="overflow: auto; font-size: 2em; align-items: center">
    Crop Shape:
    <button class="small-btn hide-on-print" (click)="changeType('qr')">QR</button>
    <button class="small-btn hide-on-print" (click)="changeType('plate')">Plate</button>
  </div>
  }
  <div style="position: relative; display: inline-block">
    @if (mode === 'takePicture') {
    <div
      style="position: absolute; border: 6px dashed red; pointer-events: none"
      [style.top.px]="overlayTop()"
      [style.left.px]="overlayLeft()"
      [style.width.px]="overlayWidth()"
      [style.height.px]="overlayHeight()"
    ></div>
    }
    <video
      [style.display]="mode === 'takePicture' ? 'block' : 'none'"
      #video
      class="camera-picture"
      id="cameraPreview"
      autoplay
    ></video>
  </div>

  <canvas #canvas width="640" height="480" style="display: none"></canvas>
  @if (mode === 'takePicture') {
  <button (click)="takePicture()">Take Picture</button>
  } @if (mode !== 'takePicture') {
  <div>
    <img class="camera-picture" [src]="takenImagePng" />
  </div>
  } @if (mode === 'processingPicture') {
  <div
    style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.8);
      z-index: 1000;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <div>Processing image...</div>
  </div>
  } @if (mode === 'showResult') {
  <div>
    <table>
      <tr>
        <th>Library</th>
        <th>Took [s]</th>
        <th>Used Image</th>
        <th>Result</th>
      </tr>
      @for (item of results; track $index) {
      <tr>
        <th>{{ item.lib }}</th>
        <td>{{ item.time }}</td>
        <td>
          @if (item.imageUsed) {
          <img class="image-preview" [src]="item.imageUsed" src="item.image" (click)="enlarge(item.imageUsed)" />
          }
        </td>
        <td>
          <div class="flex-column">
            <span>
              {{ item.result }}
            </span>
            @if (item.imageResult) {
            <img class="image-preview" [src]="item.imageResult" src="item.image" (click)="enlarge(item.imageResult)" />
            }
          </div>
        </td>
      </tr>
      }
    </table>
  </div>
  <button class="hide-on-print" (click)="mode = 'takePicture'">Try Again</button>
  <button class="hide-on-print" (click)="print()">Print 🖨️</button>
  }
</div>

<div id="myModal" class="modal" style="display: none" (click)="closeModal()">
  <div class="modal-content">
    <img id="modal-image" src="https://placehold.co/1920x1080" alt="Image" style="width: 100%" />
  </div>
</div>
